export default __webpack_public_path__ + "static/media/camera.091a3150.svg";